import type { StatusKey } from "@/lib/status";

const TINT: Record<StatusKey, string> = {
  green: "bg-status-green",
  yellow: "bg-status-yellow",
  red: "bg-status-red",
};

/**
 * A calm status sparkline — one small bar per day, colored by status (muted
 * where there's no log). Never labeled with numbers; it's a glance, not a score.
 */
export function MiniTrend({
  data,
  className = "",
  barClassName = "h-2",
}: {
  data: (StatusKey | null)[];
  className?: string;
  barClassName?: string;
}) {
  return (
    <div className={`flex items-end gap-1 ${className}`}>
      {data.map((s, i) => (
        <div
          key={i}
          className={`flex-1 rounded-sm ${barClassName} ${s ? TINT[s] : "bg-muted"}`}
        />
      ))}
    </div>
  );
}
